import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LucideIconsModule } from '@shared/lucide-icons.module';

export interface PayKpiDelta {
  value:     string;
  direction: 'up' | 'down';
}

@Component({
  selector:    'pay-kpi-tile',
  standalone:  true,
  imports:     [CommonModule, LucideIconsModule],
  templateUrl: './pay-kpi-tile.component.html',
  styleUrls:   ['./pay-kpi-tile.component.scss'],
})
export class PayKpiTileComponent {
  @Input() label:  string           = '';
  @Input() value:  string | number  = '';
  @Input() icon?:  string;
  @Input() delta?: PayKpiDelta;
  @Input() accent: boolean          = false;

  get hostClasses(): string {
    return ['pay-kpi', this.accent ? 'pay-kpi--accent' : ''].filter(Boolean).join(' ');
  }
}
